import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { NetworkStatus } from '@apollo/client';
import { usePropReaction } from '@ballpark/core';
import { PDFViewer } from '@react-pdf/renderer';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { useEffect, useMemo, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useGetUserTest } from '@marvelapp/ballpark-application';
import { BtwButton, BtwText, FullScreenLoader, Stack, } from '@marvelapp/ballpark-components';
/* import { pluralize } from '@marvelapp/core';

import { FilteringPopover } from '../NewResponses/FilteringPopover'; */
import { ResponsesContextProvider, useResponsesContext, } from '../NewResponses/ResponsesContext';
import { getColumns } from '../NewResponses/columnUtils';
import { useCreateDataQueryFromState } from '../NewResponses/responseQueryUtils';
import { AIInsightsReport } from './AIInsightsReport';
import { InsightsReportPdf } from './pdf/InsightsReportPdf';
import { InsightsReportPdfDownloadLink } from './pdf/InsightsReportPdfDownloadLink';
import { useInsightsData } from './useInsightsData';
const QualitativeInsightsContent = observer(function QualitativeInsightsContent() {
    var _a;
    const match = useRouteMatch();
    const projectPk = match.params.id;
    const context = useResponsesContext();
    const [viewMode, setViewMode] = useState('regular');
    const userTest = useGetUserTest();
    const dataQuery = useCreateDataQueryFromState();
    const { insightsData, isLoadingInsights, insightsAnalysis, isLoadingInsightsAnalysis, insightsAnalysisError, } = useInsightsData(projectPk, dataQuery);
    const isSelectionEnabled = ((_a = insightsData === null || insightsData === void 0 ? void 0 : insightsData.totalUnfilteredResponses) !== null && _a !== void 0 ? _a : 0) > 0 && !isLoadingInsights;
    const columns = useMemo(() => getColumns({
        userTest,
        projectPk,
        isSelectionEnabled,
    }), [userTest, projectPk, isSelectionEnabled]);
    const stateProps = {
        networkStatus: isLoadingInsights
            ? NetworkStatus.loading
            : NetworkStatus.ready,
        totalResults: insightsData === null || insightsData === void 0 ? void 0 : insightsData.totalUnfilteredResponses,
        totalFilteredResults: insightsData === null || insightsData === void 0 ? void 0 : insightsData.totalResponses,
        projectPk,
        columns,
    };
    useEffect(() => {
        runInAction(() => Object.assign(context, stateProps));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context]);
    usePropReaction((changedProps) => {
        Object.assign(context, changedProps);
    }, stateProps);
    // TODO: Add this back in
    // const pageError = getPageError(
    //   {
    //     data,
    //     loading,
    //     error,
    //   },
    //   MUST_PASS_ID,
    // );
    // if (pageError) {
    //   return <NotFound {...getPageErrorCopy(pageError)} />;
    // }
    if (isLoadingInsights) {
        return _jsx(FullScreenLoader, {});
    }
    if (!insightsData || (Array.isArray(insightsData) && !isLoadingInsights)) {
        return (_jsx(Stack, { gap: "6", width: "full", children: _jsx(BtwText, { children: "No insights available yet. Add some test responses first." }) }));
    }
    const totalFilteredResults = insightsData.totalResponses;
    const hasResults = dataQuery && totalFilteredResults > 0;
    const isPdfReady = hasResults && insightsAnalysis && insightsData;
    return (_jsxs(Stack, { gap: "6", width: "full", className: viewMode === 'regular' ? 'mx-auto max-w-2xl' : '', children: [_jsxs(Stack, { direction: "row", width: "full", justify: "between", className: "mb-2 pt-4", children: [_jsx(Stack, { children: _jsx(BtwText, { className: "invisible", children: "Empty text" }) }), _jsx(Stack, { direction: "row", gap: "2", children: isPdfReady && (_jsxs(_Fragment, { children: [_jsx(BtwButton, { variant: "ghost", size: "intermediate", onClick: () => setViewMode(viewMode === 'regular' ? 'pdf' : 'regular'), children: viewMode === 'regular' ? 'View PDF' : 'View Regular' }), _jsx(InsightsReportPdfDownloadLink, { insightsData: insightsData, insightsAnalysisData: insightsAnalysis })] })) })] }), dataQuery &&
                hasResults &&
                (viewMode === 'regular' ? (_jsx(AIInsightsReport, { insightsData: insightsData, totalResponses: insightsData.totalResponses, insightsAnalysisData: insightsAnalysis, isLoading: isLoadingInsightsAnalysis, error: insightsAnalysisError })) : (_jsx(PDFViewer, { className: "h-[calc(100vh-200px)] w-full", children: _jsx(InsightsReportPdf, { insightsData: insightsData, insightsAnalysisData: insightsAnalysis }) })))] }));
});
export const QualitativeInsightsPage = observer(function QualitativeInsightsPage({ isLoadingUserTestDoc, }) {
    if (isLoadingUserTestDoc)
        return null;
    return (_jsx(ResponsesContextProvider, { children: _jsx(QualitativeInsightsContent, {}) }));
});
